// extracted by mini-css-extract-plugin
export default {"ag-styles":"j_M","aboutPage":"j_W","team":"j_X","footer":"j_Y"};